import React, { useState, useEffect } from 'react';
import {
  Accordion,
  AccordionItem,
  ButtonBar,
  ButtonBarItem,
  Button,
  Fieldset,
  Field,
  FieldBody,
  Radio,
  FieldLabel,
} from '@emorg-prd/react-standard';
import './index.css';
//import Location from '../../../api/Location';
import BusinessLine from '../../../api/BusinessLine';
import LocationService from '../../../api/LocationService';
const LocationView = (props) => {
  const {
    onChange,
    handlePageError,
    locationId,
    setLocationId,
    locationName,
    locationStreetAddress1,
    locationStreetAddress2,
    country,
    countrySubdivision,
    locationCity,
    locationPostalCode,
    locationCounty,
    latitude,
    longitude,
    timezone,
    locationDesc,
    realEstateInterestList,
    primaryUseType,
    affiliateOwnershipPercentage,
    jVOwnershipPercentage,
    locationOperationStatus,
    storeBrand,
    fuelBrand,
    stewardshipCostObjectList,
    sourceSystemLinkList,
    businessLineAllocationList,
    epsBusinessLineAllocationList,
    siteName,
    siteCode,
    siteCountryId,
    sitePrimaryUseType,
    siteOperationStatus,
    itSiteCodeList,
    siteSourceLinkList,
    buildingList,
    showLoadingSpinner,
  } = props;
  const [isPageLoaded, setIsPageLoaded] = useState(false);
  let retailParentId = 8;

  const [expandedPanels, setExpandedPanels] = useState([]);
  const businessLineAllocation = businessLineAllocationList.reduce(
    (total, allocationList) => +total + +allocationList.allocationPercent, 0
  );
  const epsAllocation = epsBusinessLineAllocationList.reduce(
    (total, epsAllocationList) => +total + +epsAllocationList.epsAllocationPercent, 0
  );

  useEffect(() => {
    if (locationId) {
      showLoadingSpinner(true);
      LocationService.get(locationId).then((res) => {
        if (res.data) {
          let location = res.data;
          onChange('locationName', location.locationName);
          onChange('locationStreetAddress1', location.locationStreetAddress1);
          onChange('locationStreetAddress2', location.locationStreetAddress2 || '');
          onChange('country', {
            id: location.site.country?.countryId,
            name: location.site.country?.countryName || '',
          });
          onChange('countrySubdivision', {
            id: location.countrySubdivisionId,
            name: location.countrySubDivision?.countrySubdivisionName || '',
          });
          onChange('locationCity', location.locationCity || '');
          onChange('locationPostalCode', location.locationPostalCode || '');
          onChange('locationCounty', location.locationCounty || '');
          onChange('latitude', location.locationLat || '');
          onChange('longitude', location.locationLong || '');
          onChange('locationDesc', location.locationDesc || '');
          onChange('timezone', {
            timezoneId: location.timezoneId,
            timezoneName: location.timeZone?.timezoneName || '',
          });
          onChange(
            'realEstateInterestList',
            location.realEstateInterest.map((rei) => ({
              isNew: false,
              locationId: rei.locationId,
              realEstateInterestId: rei.realEstateInterestId,
              realEstateInterestName: rei.realEstateInterestName || '',
              realEstateInterestTypeId: rei.realEstateInterestTypeId,
              realEstateInterestTypeName: rei.realEstateInterestType?.realEstateInterestTypeName,
              primary: rei.isPrimaryRealEstateInterest,
              realEstateInterestDesc: rei.realEstateInterestDesc || '',
              realEstateInterestLatitude: rei.realEstateInterestLatitude || '',
              realEstateInterestLongitude: rei.realEstateInterestLongitude || '',
              realEstateInterestFrontageSize: rei.realEstateInterestFrontageSize || '',
              realEstateInterestDepthSize: rei.realEstateInterestDepthSize || '',
              realEstateInterestArea: rei.realEstateInterestArea || '',
              realEstateInterestSizeUOM: rei.realEstateInterestSizeUOM || '',
              realEstateInterestBusinessLineAlias: rei.realEstateInterestBusinessLineAlias || '',
              realEstateInterestSourceSystemRelate:
                rei.realEstateInterestSourceSystemRelateData.map((source) => ({
                  reiSourceSystemRelateId: source.reiSourceSystemRelateId,
                  realEstateInterestId: source.realEstateInterestId,
                  realEstateInterestSourceSystemId: source.sourceSystemId,
                  realEstateInterestSourceSystemName: source.sourceSystem?.sourceSystemName || '',
                  realEstateInterestSourceSystemTypeId: source.sourceSystemIdTypeId,
                  realEstateInterestSourceSystemIdTypeName: source.sourceSystemIdType?.sourceSystemIdTypeName || '',
                  realEstateInterestSourceSystemReferenceID: source.sourceSystemReferenceId || '',
                })) || [],
            }))
          );
          onChange(
            'realEstateInterestDropdown',
            new Array(location.realEstateInterest.length).fill([])
          );
          onChange('primaryUseType', {
            id: location.primaryUseTypeId,
            name: location.primaryUseType?.primaryUseTypeName || '',
            parentId: location.primaryUseType?.primaryUseTypeParentId,
            isActive: location.primaryUseType.isActive.toLowerCase() === 'y' ? true : false
          });
          onChange('isJointVenture', location.jVOwnershipPercentage ? true : false);
          onChange('affiliateOwnershipPercentage', location.affiliateOwnershipPercentage);
          onChange('jVOwnershipPercentage', location.jVOwnershipPercentage);
          onChange('locationOperationStatus', {
            id: location.operationStatusId,
            name: location.operationStatus?.operationStatusName || '',
            isActive: location.operationStatus?.isActive.toLowerCase() === 'y' ? true : false
          });
          onChange('storeBrand', {
            id: location.storeBrandId,
            name: location.storeBrand?.storeBrandName || '',
          });
          onChange('fuelBrand', {
            id: location.fuelBrandId,
            name: location.fuelBrand?.fuelBrandName || '',
          });
          onChange(
            'stewardshipCostObjectList',
            location.locationStewardCostObject.map((sco) => ({
              id: sco.id,
              stewardshipTypeId: sco.stewardshipTypeId,
              stewardshipTypeName: sco.stewardshipType?.stewardshipTypeName || '',
              costObjectTypeId: sco.costObjectTypeId,
              costObjectTypeName: sco.costObjectType?.costObjectTypeName || '',
              costObject: sco.costObject,
            }))
          );
          onChange(
            'sourceSystemLinkList',
            location.locationSourceSystemRelate.map((locationSource) => {
              return {
                locationSourceSystemId: locationSource.locationSourceSystemId,
                sourceSystemId: locationSource.sourceSystem?.sourceSystemId,
                sourceSystemName: locationSource.sourceSystem?.sourceSystemName || '',
                sourceSystemIdTypeId: locationSource.sourceSystemIdTypeId,
                originalSourceSystemIdTypeId: locationSource.sourceSystemIdTypeId,
                sourceSystemIdTypeName: locationSource.sourceSystemIdType?.sourceSystemIdTypeName || '',
                sourceSystemReferenceId: locationSource.sourceSystemReferenceId,
                originalSourceSystemReferenceId: locationSource.sourceSystemReferenceId,
                sourceSystemIsActive: locationSource.sourceSystem?.isActive.toLowerCase() === 'y' ? true : false,
                sourceSystemIdTypeIsActive: locationSource.sourceSystemIdType?.isActive,
                isSourceSystemValid: true,
                isLoading: false,
                validationErrorMessage: ''
              };
            })
          );
          if (location.locationBusinessLineRelate.length) {
            let businessLineList = [];
            location.locationBusinessLineRelate.forEach(async (element) => {
              showLoadingSpinner(true);
              let filteredList = await BusinessLine.getByReportingUnit(
                element.businessLineReportingUnit.company_code
              );
              showLoadingSpinner(false);
              let bsLineFilteredList = [];
              filteredList.forEach((filterElement) => {
                bsLineFilteredList.push({
                  business_division_code: filterElement.business_division_code,
                  business_line_acronym: filterElement.business_line_acronym || '',
                  business_line_code: filterElement.business_line_code,
                  business_line_name: filterElement.business_line_name || '',
                  businessLineReportUnit: element.businessLineReportingUnit.company_code || '',
                });
              });
              let businessLineObject = {
                locationId: element.locationId,
                businessLineLocationId: element.businessLineLocationId,
                allocationPercent: element.allocationPercent,
                businessLineCode: element.business_line_code || '',
                businessLineName: element.businessLine.business_line_name || '',
                businessLineReportUnitCompanyCode:
                  element.businessLineReportingUnit.company_code || '',
                businessLineReportUnitName:
                  (element.businessLineReportingUnit.company_code +
                    ' - ' +
                    element.businessLineReportingUnit.company_name) || '',
                businessLineFilteredList: bsLineFilteredList,
              };
              businessLineList.push(businessLineObject);
              onChange('businessLineAllocationList', businessLineList);
            });
          } else {
            let newBusinessLineList = [
              {
                businessLineCode: 0,
                businessLineName: '',
                businessLineReportUnitCompanyCode: 0,
                businessLineReportUnitName: '',
                allocationPercent: 0,
                businessLineFilteredList: [],
                locationId: '',
              },
            ]
            onChange('businessLineAllocationList', newBusinessLineList);
          }
          if (location.locationEPSBusinessLineRelate.length) {
            onChange(
              'epsBusinessLineAllocationList',
              location.locationEPSBusinessLineRelate.map((epsBusinessLine) => {
                return {
                  location_eps_bl_relate_id: epsBusinessLine.location_eps_bl_relate_id,
                  eps_business_vc_id: epsBusinessLine.eps_business_vc_id,
                  businessValueChain: epsBusinessLine.epsBusinessValueChain?.short_description || '',
                  eps_business_line_id: epsBusinessLine.eps_business_line_id,
                  businessLine: epsBusinessLine.epsBusinessLine?.short_description || '',
                  epsAllocationPercent: epsBusinessLine.allocationPercent,
                };
              })
            );
          } else {
            let newEpsBusinessLineList = [
              {
                eps_business_vc_id: 0,
                businessValueChain: '',
                eps_business_line_id: 0,
                businessLine: '',
                epsAllocationPercent: 0,
              }
            ];
            onChange('epsBusinessLineAllocationList', newEpsBusinessLineList);
          }
          onChange('siteId', location.siteId);
          onChange('siteName', location.site.siteName);
          onChange('siteCode', location.site.siteCode);
          onChange('siteOperationStatusId', location.site.operationStatusId);
          onChange(
            'siteOperationStatus',
            location.site.operationStatus?.operationStatusName || ''
          );
          onChange('sitePrimaryUseTypeId', location.site.primaryUseTypeId);
          onChange('siteCountryId', location.site.countryId);
          onChange(
            'sitePrimaryUseType',
            location.site.primaryUseType?.primaryUseTypeName || ''
          );
          onChange(
            'itSiteCodeList',
            location.site.itSiteCodeRelate.map((siteItSiteCode) => ({
              itSiteCodeRelateId: siteItSiteCode.itSiteCodeRelateId || '',
              itSiteCodeId: siteItSiteCode.itSiteCodeId || '',
              itSiteCode: siteItSiteCode.itSiteCode?.itSiteCode || '',
              siteId: siteItSiteCode.siteId,
              itSiteCodeDesc: siteItSiteCode.itSiteCode?.itSiteCodeDesc || '',
            }))
          );
          onChange(
            'siteSourceLinkList',
            location.site.siteSourceSystemRelate.map((siteSource) => ({
              siteSourceSystemId: siteSource.siteSourceSystemId,
              siteId: siteSource.siteId || '',
              sourceSystemId: siteSource.sourceSystem?.sourceSystemId || '',
              sourceSystemName: siteSource.sourceSystem?.sourceSystemName || '',
              sourceSystemIsActive: siteSource.sourceSystem?.isActive.toLowerCase() === 'y' ? true : false,
              sourceSystemIdTypeName: siteSource.sourceSystemIdType?.sourceSystemIdTypeName || '',
              sourceSystemIdTypeId: siteSource.sourceSystemIdTypeId,
              originalSourceSystemIdTypeId: siteSource.sourceSystemIdTypeId,
              sourceSystemReferenceId: siteSource.sourceSystemReferenceId,
              originalSourceSystemReferenceId: siteSource.sourceSystemReferenceId,
              sourceSystemIdTypeIsActive: siteSource.sourceSystemIdType?.isActive,
              isSourceSystemValid: true,
              isLoading: false,
              validationErrorMessage: ''
            }))
          );
          onChange(
            'buildingList',
            location.building.map((building) => ({
              buildingId: building.buildingId || 0,
              buildingName: building.buildingName || '',
              buildingDesc: building.buildingDesc || '',
              sourceSystemId: building.buildingSourceSystemRelate.find(x => x.sourceSystemIdTypeId == 22)?.buildingSourceSystemId || 0,
              sourceSystemReferenceId: building.buildingSourceSystemRelate.find(x => x.sourceSystemIdTypeId == 22)?.sourceSystemReferenceId || '',
              sourceSystemIdTypeId: building.buildingSourceSystemRelate.find(x => x.sourceSystemIdTypeId == 22)?.sourceSystemIdTypeId || 0,
              isNuvoloBuildingValid: building.buildingSourceSystemRelate.find(x => x.sourceSystemIdTypeId == 22)?.sourceSystemReferenceId ? true : false,
              previousNuvoloBuildingId: building.buildingSourceSystemRelate.find(x => x.sourceSystemIdTypeId == 22)?.sourceSystemReferenceId || '',
              validationSymbol: '',
              loadingValidation: false,
              validationErrorMessage: ''
            }))
          );
          setIsPageLoaded(true);
          showLoadingSpinner(false);
        } else {
          setLocationId(0);
        }
      }).catch((error) => {
        handlePageError(error.message);
      });
    } else {
      setIsPageLoaded(true);
    }
  }, [locationId]);

  const handlePanelChange = (e, value) => {
    if (expandedPanels.includes(value)) {
      setExpandedPanels(expandedPanels.filter((panel) => panel !== value));
    } else {
      setExpandedPanels([...expandedPanels, value]);
    }
  };

  function renderPage() {
    if (isPageLoaded && locationName) {
      return (
        <div className='displayAccordion'>
          <div
            style={{
              paddingBottom: '1px',
              maxWidth: '1600px' /* same width as em-c-accordion */,
            }}
          >
            <ButtonBar style={{ float: 'right' }}>
              <ButtonBarItem>
                <Button
                  style={{ borderWidth: '0 3px 0 0' }}
                  size='small'
                  onClick={() => setExpandedPanels([1, 2, 3, 4])}
                >
                  Expand
                </Button>
              </ButtonBarItem>
              <ButtonBarItem>
                <Button
                  style={{ borderWidth: '0 0 0 0' }}
                  size='small'
                  onClick={() => setExpandedPanels([])}
                >
                  Collapse
                </Button>
              </ButtonBarItem>
            </ButtonBar>
          </div>
          <Accordion
            style={{ marginTop: '40px' }}
            expanded={expandedPanels}
            onChange={handlePanelChange}
          >
            <AccordionItem title='Location' value={1} id='AccordionLocation'>
              <Fieldset>
                <h6>Location Name</h6>
                <p className='field-value'>{locationName}</p>

                <h6>Street Address 1</h6>
                <p className='field-value'>{locationStreetAddress1}</p>
                
                <h6>Street Address 2</h6>
                <p className='field-value'>{locationStreetAddress2 || '--'}</p>

                <div className='review-row'>
                  <div className='row-item2'>
                    <h6>City</h6>
                    <p className='field-value'>{locationCity || '--'}</p>
                  </div>

                  <div>
                    <h6>Postal Code</h6>
                    <p className='field-value'>{locationPostalCode || '--'}</p>
                  </div>
                </div>

                <div className='review-row'>
                  <div className='row-item2'>
                    <h6>Country</h6>
                    <p className='field-value'>{country.name}</p>
                  </div>

                  <div>
                    <h6>State/Province</h6>
                    <p className='field-value'>{countrySubdivision.name || '--'}</p>
                  </div>
                </div>

                <div className='review-row'>
                  <div className='row-item2'>
                    <h6>County</h6>
                    <p className='field-value'>{locationCounty || '--'}</p>
                  </div>

                  <div className='row-item2'>
                    <h6>Latitude</h6>
                    <p className='field-value'>{latitude || '--'}</p>
                  </div>

                  <div>
                    <h6>Longitude</h6>
                    <p className='field-value'>{longitude || '--'}</p>
                  </div>
                </div>

                <h6>Timezone</h6>
                <p className='field-value'>{timezone.timezoneName}</p>
              </Fieldset>

              <Fieldset>
                <h6>Location Description</h6>
                <p className='field-value description-wrap'>{locationDesc || '--'}</p>
              </Fieldset>

              <div style={{ paddingTop: '20px' }}>
                {realEstateInterestList.map((realEstateInterest, index) => (
                  <Fieldset key={index}>
                    <Field
                      key={`${realEstateInterest}~${index}`}
                      style={{ marginBottom: '20px' }}
                    >
                      <FieldLabel></FieldLabel>
                      <FieldBody>
                        <div className='review-row'>
                          <div className='row-item'>
                            <h6>Real Estate Interest</h6>
                            <p className='field-value'>
                              {realEstateInterest.realEstateInterestName}
                            </p>
                          </div>

                          <div className='row-item2'>
                            <h6>Interest Type</h6>
                            <p className='field-value'>
                              {realEstateInterest.realEstateInterestTypeName}
                            </p>
                          </div>

                          <Radio
                            disabled
                            style={{
                              paddingTop: '10px',
                              paddingLeft: '5px',
                              border: 0,
                              background: 'transparent',
                            }}
                            label='Primary'
                            value={index}
                            checked={realEstateInterest.primary}
                          />
                        </div>

                        <div className='row-item'>
                          <h6>Real Estate Interest Description</h6>
                          <p className='field-value description-wrap'>
                            {realEstateInterest.realEstateInterestDesc || '--'}
                          </p>
                        </div>

                        <div className='review-row'>
                          <div className='row-item2'>
                            <h6>UOM</h6>
                            <p className='field-value'>
                              {realEstateInterest.realEstateInterestSizeUOM || '--'}
                            </p>
                          </div>

                          <div className='row-item2'>
                            <h6>Area</h6>
                            <p className='field-value'>
                              {realEstateInterest.realEstateInterestArea || '--'}
                            </p>
                          </div>
                        </div>

                        <div>
                          {realEstateInterest.realEstateInterestSourceSystemRelate.map(
                            (source, sourceIndex) => (
                              <Field key={`${source}~${sourceIndex}`}>
                                <FieldLabel></FieldLabel>
                                <FieldBody>
                                  <div className='review-row'>
                                    <div className='row-item'>
                                      <h6>Source System</h6>
                                      <p className='field-value'>
                                        {source.realEstateInterestSourceSystemName ||
                                          '--'}
                                      </p>
                                    </div>
                                    <div className='row-item'>
                                      <h6>Source System Type</h6>
                                      <p className='field-value'>
                                        {source.realEstateInterestSourceSystemIdTypeName ||
                                          '--'}
                                      </p>
                                    </div>
                                    <div>
                                      <h6>Source System Reference ID</h6>
                                      <p className='field-value'>
                                        {source.realEstateInterestSourceSystemReferenceID ||
                                          '--'}
                                      </p>
                                    </div>
                                  </div>
                                </FieldBody>
                              </Field>
                            )
                          )}
                        </div>
                      </FieldBody>
                    </Field>
                  </Fieldset>
                ))}
              </div>
            </AccordionItem>

            <AccordionItem
              title='Location Details'
              value={2}
              id='AccordionLocationDetails'
            >
              <Fieldset>
                <div className='review-row'>
                  <div className='row-item'>
                    <h6>Location Primary Use</h6>
                    <p className='field-value'>{primaryUseType.name}</p>
                  </div>

                  <div>
                    <h6>
                      {affiliateOwnershipPercentage
                        ? 'Working Interest'
                        : 'Joint Ownership'}
                    </h6>
                    <p className='field-value'>
                      {affiliateOwnershipPercentage
                        ? affiliateOwnershipPercentage
                        : jVOwnershipPercentage}{' '}
                      %
                    </p>
                  </div>
                </div>

                <div className='review-row'>
                  <div className='row-item'>
                    <h6>Operation Status</h6>
                    <p className='field-value'>{locationOperationStatus.name}</p>
                  </div>
                </div>

                <div>
                  {primaryUseType.parentId === retailParentId ? (
                    <div className='review-row'>
                      <div className='row-item'>
                        <h6>Store Brand</h6>
                        <p className='field-value'>{storeBrand.name || '--'}</p>
                      </div>

                      <div>
                        <h6>Fuel Brand</h6>
                        <p className='field-value'>{fuelBrand.name || '--'}</p>
                      </div>
                    </div>
                  ) : (
                      ''
                    )}
                </div>
              </Fieldset>

              <Fieldset>
                <div>
                  {stewardshipCostObjectList.map((stewardshipCostObject, index) => (
                    <Field key={`${stewardshipCostObject}~${index}`}>
                      <FieldLabel></FieldLabel>
                      <FieldBody>
                        <div className='review-row'>
                          <div className='row-item'>
                            <h6>Stewardship Type</h6>
                            <p className='field-value'>
                              {stewardshipCostObject.stewardshipTypeName || '--'}
                            </p>
                          </div>

                          <div className='row-item'>
                            <h6>Cost Object Type</h6>
                            <p className='field-value'>
                              {stewardshipCostObject.costObjectTypeName || '--'}
                            </p>
                          </div>

                          <div>
                            <h6>Cost Object</h6>
                            <p className='field-value'>
                              {stewardshipCostObject.costObject || '--'}
                            </p>
                          </div>
                        </div>
                      </FieldBody>
                    </Field>
                  ))}
                </div>
              </Fieldset>

              <div>
                {sourceSystemLinkList.map((sourceSystemLink, index) => (
                  <Field key={`${sourceSystemLink}~${index}`}>
                    <FieldLabel></FieldLabel>
                    <FieldBody>
                      <div className='review-row'>
                        <div className='row-item'>
                          <h6>Source System</h6>
                          <p className='field-value'>
                            {sourceSystemLink.sourceSystemName || '--'}
                          </p>
                        </div>

                        <div className='row-item'>
                          <h6>Source System Type</h6>
                          <p className='field-value'>
                            {sourceSystemLink.sourceSystemIdTypeName || '--'}
                          </p>
                        </div>

                        <div>
                          <h6>Source System Reference ID</h6>
                          <p className='field-value'>
                            {sourceSystemLink.sourceSystemReferenceId || '--'}
                          </p>
                        </div>
                      </div>
                    </FieldBody>
                  </Field>
                ))}
              </div>
            </AccordionItem>

            <AccordionItem title='Business Line' value={3} id='AccordionBusinessLine'>
              <div>
                <Fieldset style={{ paddingBottom: '0px' }}>
                  {businessLineAllocationList.map((businessLineAllocation, index) => (
                    <Field key={`${businessLineAllocation}~${index}`}>
                      <FieldLabel></FieldLabel>
                      <FieldBody>
                        <div className='review-row'>
                          <div className='row-item'>
                            <h6>Business Line Report Unit</h6>
                            <p className='field-value' style={{ width: '540px' }}>
                              {businessLineAllocation.businessLineReportUnitName || '--'}
                            </p>
                          </div>
                          <div className='row-item'>
                            <h6>Business Line</h6>
                            <p className='field-value' style={{ width: '300px' }}>
                              {businessLineAllocation.businessLineName || '--'}
                            </p>
                          </div>

                          <div>
                            <h6>Allocation %</h6>
                            <p className='field-value' style={{ width: '90px' }}>
                              {businessLineAllocation.allocationPercent}
                            </p>
                          </div>
                        </div>
                      </FieldBody>
                    </Field>
                  ))}
                  <div className='total-percent'>
                    {' '}
                    Total Percentage: {businessLineAllocation.toPrecision(3)} %
                  </div>
                </Fieldset>
                <Fieldset style={{ paddingBottom: '0px' }}>
                  {epsBusinessLineAllocationList.map((epsBusinessAllocation, index) => (
                    <Field key={`${epsBusinessAllocation}~${index}`}>
                      <FieldLabel></FieldLabel>
                      <FieldBody>
                        <div className='review-row'>
                          <div className='row-item'>
                            <h6>Value Chain</h6>
                            <p className='field-value' style={{ width: '540px' }}>
                              {epsBusinessAllocation.businessValueChain || '--'}
                            </p>
                          </div>
                          <div className='row-item'>
                            <h6>E&PS Business Line</h6>
                            <p className='field-value' style={{ width: '300px' }}>
                              {epsBusinessAllocation.businessLine || '--'}
                            </p>
                          </div>

                          <div>
                            <h6>Allocation %</h6>
                            <p className='field-value' style={{ width: '90px' }}>
                              {epsBusinessAllocation.epsAllocationPercent}
                            </p>
                          </div>
                        </div>
                      </FieldBody>
                    </Field>
                  ))}
                  <div className='total-percent'>
                    {' '}
                    Total Percentage: {epsAllocation.toPrecision(3)} %
                  </div>
                </Fieldset>
              </div>
            </AccordionItem>

            <AccordionItem title='Site' value={4} id='AccordionSite'>
              <div>
                <Fieldset>
                  <h6>Site Name</h6>
                  <p className='field-value'>{siteName}</p>

                  <h6>Site Country</h6>
                  <p className='field-value'>{country.name}</p>

                  <h6>Site Code</h6>
                  <p className='field-value'>{siteCode}</p>

                  <h6>Primary Use</h6>
                  <p className='field-value'>{sitePrimaryUseType}</p>

                  <h6>Operation Status</h6>
                  <p className='field-value'>{siteOperationStatus}</p>
                </Fieldset>

                <Fieldset>
                  <div>
                    {itSiteCodeList.map((siteCodeList, index) => (
                      <Field key={`${siteCodeList}~${index}`}>
                        <FieldLabel></FieldLabel>
                        <FieldBody>
                          <h6>IT Site Code</h6>
                          <p className='field-value'>{siteCodeList.itSiteCode || '--'}</p>
                        </FieldBody>
                      </Field>
                    ))}
                  </div>
                </Fieldset>

                <div style={{ paddingTop: '20px' }}>
                  {siteSourceLinkList.map((siteSourceLink, index) => (
                    <Field key={`${siteSourceLink}~${index}`}>
                      <FieldLabel></FieldLabel>
                      <FieldBody>
                        <div className='review-row'>
                          <div className='row-item'>
                            <h6>Site Source System</h6>
                            <p className='field-value'>
                              {siteSourceLink.sourceSystemName || '--'}
                            </p>
                          </div>

                          <div className='row-item'>
                            <h6>Source System Type</h6>
                            <p className='field-value'>
                              {siteSourceLink.sourceSystemIdTypeName || '--'}
                            </p>
                          </div>

                          <div>
                            <h6>Source System Reference ID</h6>
                            <p className='field-value'>
                              {siteSourceLink.sourceSystemReferenceId || '--'}
                            </p>
                          </div>
                        </div>
                      </FieldBody>
                    </Field>
                  ))}
                </div>
              </div>
            </AccordionItem>

            <AccordionItem title='Buildings' value={5} id='AccordionBuilding'>
              <div>
                <Fieldset style={{ paddingBottom: '0px' }}>
                  {buildingList.map((building, index) => (
                    <Field key={`${building}~${index}`}>
                      <FieldLabel></FieldLabel>
                      <FieldBody>
                        <div className='review-row'>
                          <div className='row-item'>
                            <h6>Building Name</h6>
                            <p className='field-value' style={{ width: '400px' }}>
                              {building.buildingName || '--'}
                            </p>
                          </div>

                          <div className='row-item'>
                            <h6>Building Description</h6>
                            <p className='field-value' style={{ width: '400px' }}>
                              {building.buildingDesc || '--'}
                            </p>
                          </div>

                          <div className='row-item'>
                            <h6>Nuvolo Source System Reference Id</h6>
                            <p className='field-value' style={{ width: '270px' }}>
                              {building.sourceSystemReferenceId || '--'}
                            </p>
                          </div>
                        </div>
                      </FieldBody>
                    </Field>
                  ))}
                </Fieldset>
              </div>
            </AccordionItem>

          </Accordion>
        </div>
      );
    } else if (isPageLoaded && locationId === 0) {
      showLoadingSpinner(false);
      return (
        <div>
          <h1 style={{ textAlign: 'center', fontSize: '2rem' }}> Not Found </h1>
        </div>
      );
    } else {
      return <div></div>;
    }
  }
  return renderPage();
};

export default LocationView;
